module.exports = require("react-responsive");


//////////////////
// WEBPACK FOOTER
// external "react-responsive"
// module id = 20
// module chunks = 0